import { render } from "./PR15-081922.vue?vue&type=template&id=9fd836e6"
import script from "./PR15-081922.vue?vue&type=script&lang=js"
export * from "./PR15-081922.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__